const { instance } = require('./url')

async function getDrawingMetadata(quoteId) {
    return await instance.get('/drawingmetadata/' + quoteId)
}

async function updateDrawingMetadata(quoteId, signGivenId, partId, attributes) {
    return await instance.put('/drawingmetadata/' + quoteId, {
        'sign_given_id': signGivenId,
        'part_id': partId,
        'attributes': attributes,
    })
}

async function insertDrawingMetadata(quoteId, signGivenId, partId, attributes) {
    return await instance.post('/drawingmetadata/' + quoteId, {
        'sign_given_id': signGivenId,
        'part_id': partId,
        'attributes': attributes,
    })
}

async function deleteDrawingMetadataField(quoteId, signGivenId, partId, key) {
    return await instance.delete('/drawingmetadata/' + quoteId, {
        data: {
            'sign_given_id': signGivenId,
            'part_id': partId,
            'key': key,
        },
    })
}

async function deleteDrawingMetadataRow(quoteId, signGivenId, partId) {
    return await instance.delete('/drawingmetadata/' + quoteId, {
        data: {
            'sign_given_id': signGivenId,
            'part_id': partId,
        },
    })
}

async function clearDrawingMetadata(quoteId) {
    return await instance.delete('/drawingmetadata/' + quoteId, {
        data: {
            'clear_all': true,
        },
    })
}

export {
    getDrawingMetadata,
    updateDrawingMetadata,
    insertDrawingMetadata,
    deleteDrawingMetadataField,
    deleteDrawingMetadataRow,
    clearDrawingMetadata,
}
